import {
	Component,
	ChangeDetectionStrategy,
	OnInit,
	inject,
	ViewChild,
	ElementRef,
	ChangeDetectorRef,
	afterNextRender,
	AfterRenderPhase,
	PLATFORM_ID,
	Inject
} from '@angular/core';
import _ from 'lodash';
import {
	isPlatformBrowser
} from '@angular/common';
import { SeoService } from 'app/services/seo.service';

@Component({
	selector: 'about-us',
	templateUrl: '../templates/about-us.pug',
	styleUrls: ['../styles/about-us.scss'],
	host: { class: 'about-us' },
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutUsComponent implements OnInit {

	@ViewChild( 'toolbar' )
	protected toolbar!: ElementRef;
	@ViewChild( 'navbar' )
	protected navbar!: ElementRef;
	@ViewChild( 'hero' )
	protected hero!: ElementRef;

	protected readonly _cdr: ChangeDetectorRef
		= inject( ChangeDetectorRef );

	protected filterType: string;
	protected searchValue: string;

	constructor(
		@Inject( PLATFORM_ID ) private _platformId: Object,
		private _seo: SeoService
	) {
		afterNextRender(() => {
			if ( isPlatformBrowser( this._platformId ) ) {
			}
		}, { phase: AfterRenderPhase.MixedReadWrite });
	}

	ngOnInit(): void {
		this._seo.updateTags([
			{ name: 'description', content: 'Giới thiệu về Đồng Quê - Đơn vị cung cấp thực phẩm sạch, an toàn tại Quy Nhơn, Gia Lai.' },
			{ name: 'keywords', content: 'giới thiệu, về chúng tôi, thực phẩm sạch, Quy Nhơn, Gia Lai' },
			{ property: 'og:title', content: 'Về Đồng Quê - Thực Phẩm Sạch Quy Nhơn' },
			{ property: 'og:description', content: 'Thực phẩm tươi sống, sạch và an toàn tại Quy Nhơn, Gia Lai.' }
		]);
		this._seo.setLink();
	}
}
